// src/lib/useActivityLogger.js
// Returns a pre-filled logActivity function so pages don't have to
// repeat firmId / userId boilerplate.

import { useCallback } from 'react';
import { useFirm } from '../contexts/FirmContext';
import { useAuth } from '../contexts/AuthContext';
import { logActivity } from './db';

/**
 * Usage:
 *   const log = useActivityLogger();
 *   log('matter', matter.id, 'created', `Case "${matter.title}" created`);
 *   log('contact', contact.id, 'deleted', `Contact "${name}" removed`);
 *
 * Optionally pass a matter_id as 5th arg for entries linked to a case.
 * Always fire-and-forget — never await or block on it.
 */
export function useActivityLogger() {
  const { firmId } = useFirm();
  const { userProfile } = useAuth();

  return useCallback(
    (entityType, entityId, action, summary, matterId = null) => {
      if (!firmId) return;
      logActivity(firmId, {
        entity_type: entityType,
        entity_id:   entityId   || null,
        action,
        summary,
        user_id:     userProfile?.id || null,
        matter_id:   matterId        || null,
      });
    },
    [firmId, userProfile?.id],
  );
}
